import ResourceToken from '@apps/maha/admin/tokens/resource'
import ResourceCard from '@apps/maha/admin/cards/resource'
import Panel from '@admin/components/panel'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Resources)',
  collection: {
    endpoint: '/api/admin/team/resources',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Title)', key: 'title', primary: true, format: (resource) => (
        <ResourceToken resource={ resource } />
      ) }
    ],
    empty: {
      title: 't(No Resources)',
      text: 't(There are no resources)',
      svg: 'library'
    },
    card: (resource) => (
      <ResourceCard resource={ resource } />
    ),
    entity: 'team',
    defaultSort: { key: 'created_at', order: 'desc' },
    onClick: (record) => {
      if(record.type === 'document') {
        window.location.href = record.remix_url || `/api/admin/assets/${record.asset.fingerprint}/download?token=${context.admin.token}`
      } else {
        context.host.window.open(record.remix_url)
      }
    }
  }
})

export default Panel(null, mapPropsToPanel)
